import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from '../common/Translate';

export const Bank = props => {

    const { subAktif, setSubAktif } = props;

    return (
        <div className="first-level__sub-items">
            <ul className="second-level">
                <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-file-empty"></use>
                    </svg>
                    <Link className={`second-level__definition${(subAktif === 'bankahareketleri' ? ' active' : '')}`} to="/bank-activity" onClick={e => { setSubAktif('bankahareketleri'); }}>
                        <span className="second-level__span">
                            <Translate>Banka Kasa</Translate>
                        </span>
                    </Link>
                </li>
                {<li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-credit-card"></use>
                    </svg>
                    <Link className="second-level__definition" to="/activity-summary">
                        <span className="second-level__span">
                            <Translate>Özet Banka</Translate>
                        </span>
                    </Link>
                </li>}
            </ul>
        </div>
    )
}